module.exports = __webpack_public_path__ + "static/media/028.4d9b6e75.jpg";